<!-- 没有导航栏和低栏的error page -->
<template>
  <div class="error-layout">
    <nuxt />
  </div>
</template>

<script>
export default {
  mounted() {
    this.$log && this.$log.error('error page');
  }
};
</script>
